import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PHONE_PREFIXES } from '../phone-prefixes';

@Component({
  selector: 'app-phone-input',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './phone-input.component.html',
  styleUrl: './phone-input.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneInputComponent),
      multi: true,
    },
  ],
})
export class PhoneInputComponent implements ControlValueAccessor {
  @Input() placeholder = '333 000 0000';

  prefixes = PHONE_PREFIXES;
  prefix = this.prefixes[0].code;
  number = '';
  disabled = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  private readonly prefixesByLength = [...this.prefixes].sort((a, b) => b.code.length - a.code.length);

  writeValue(value: string): void {
    const raw = (value ?? '').trim();
    if (!raw) {
      this.prefix = this.prefixes[0].code;
      this.number = '';
      return;
    }

    const match = this.prefixesByLength.find((p) => raw.startsWith(p.code));

    if (match) {
      this.prefix = match.code;
      this.number = raw.slice(match.code.length).trim();
    } else {
      // Numero salvato senza prefisso riconosciuto: non lo si perde, resta nel campo numero.
      this.prefix = this.prefixes[0].code;
      this.number = raw;
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onPrefixChange(code: string): void {
    this.prefix = code;
    this.emitValue();
  }

  // Numero incollato con il prefisso davanti (+39… o 0039…): il prefisso va nel menu, non nel numero
  onNumberChange(value: string, input: HTMLInputElement): void {
    const intl = value.trim().replace(/^00/, '+');
    const match = intl.startsWith('+') ? this.prefixesByLength.find((p) => intl.startsWith(p.code)) : undefined;
    if (match) {
      this.prefix = match.code;
      this.number = intl.slice(match.code.length).trim();
      input.value = this.number;
    } else {
      this.number = value;
    }
    this.emitValue();
  }

  private emitValue(): void {
    this.onTouched();
    const trimmed = this.number.trim();
    this.onChange(trimmed ? `${this.prefix} ${trimmed}` : '');
  }
}
